<template>
    <div id="topCollapseButton" @click="toggleOptionState" :class="{collapsed: isCollapsed}">
        <span v-if="isCollapsed" title="Klap menubalk uit">▼</span>
        <span v-else title="Klap menubalk in">▲</span>
    </div>
</template>

<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator';

    @Component
    export default class OptionsAndFilterCollapser extends Vue {
        public isCollapsed: boolean = false;

        public toggleOptionState(): void {
            this.isCollapsed = !this.isCollapsed;

            if (this.isCollapsed) {
                const applicationBoardContainer: HTMLElement | null = document.querySelector('#planbord');
                if (applicationBoardContainer) {
                    applicationBoardContainer.classList.add('collapsed');
                }
            } else {
                const applicationBoardContainer: HTMLElement | null = document.querySelector('#planbord');
                if (applicationBoardContainer) {
                    applicationBoardContainer.classList.remove('collapsed');
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    #topCollapseButton {
        background: #fff;
        box-shadow: var(--generic-shadow-subtle);
        align-self: flex-end;
        right: 15px;
        position: absolute;
        cursor: pointer;
        height: 20px;
        width: 20px;
        text-align: center;
        line-height: 10px;
        padding-top: 4px;
        border: 1px solid #ddd;
        border-radius: 4px;
        z-index: 300;
        transition: all .5s ease;
    }

    #topCollapseButton.collapsed {
        border-color: #000;
        background: #000;
        color: #fff;
        align-self: flex-start;
    }
</style>
